<div [formGroup]="form" class="flex flex-col tk-bg-gray-5 h-full">

  <div class="p-4 flex align-middle">
    <app-arrow-left-button class="mr-2 mt-2 " (close)="onBackToList()"></app-arrow-left-button>
    <span class="font-semibold text-xl">{{header}}</span>
  </div>

  <div class="flex h-full">
    <dsm-vehicles-list *ngIf="!isViewMode" class="ml-4 w-1/4  h-full" [selectedVehicles]="$any(vehiclesCtrl.value)"
                       (selectionChanged)="onVehiclesSelected($event)">
    </dsm-vehicles-list>

    <div class="ml-3 flex grow flex-col">
      <dsm-link-name *ngIf="!isViewMode" formControlName="name"></dsm-link-name>

      <dsm-selected-vehicles formControlName="vehicles" [isViewMode]="isViewMode"></dsm-selected-vehicles>

      <dsm-link-activity [isViewMode]="isViewMode" [readonlyDateRange]="existingLinkDateRange"
                         (dateChanged)="onDateRangeChanged($event)">
      </dsm-link-activity>

      <div *ngIf="!isViewMode" class="mt-2 flex flex-col bg-white px-6 py-4 rounded-xl">

        <div *ngIf="formError" class="tk-c-red text-base mb-3">{{formError}}</div>

        <div class="flex items-center">
          <app-button id="btn-save" [isLoading]="isLoading" [isFullWidth]="true" [isActive]="isFormValid" innerTextClasses="mx-3"
                      spinnerClasses="mx-5 my-1.5" label="{{'labels.save' | translate | titlecase}}" class="mr-3"
                      (click)="onSave()">
          </app-button>

          <sm-button-transparent label="{{'labels.cancel' | translate | titlecase}}" class="ml-3" (click)="onCancel()">
          </sm-button-transparent>
        </div>

      </div>
    </div>
  </div>

</div>
